export default __webpack_public_path__ + "static/inner-belief_big-image-2-43df1449eaa61a348a42a455e4afe3ad.webp";